import React, { Component } from 'react'
import PropTypes from 'prop-types'
import onClickOutside from 'react-onclickoutside'
import { connect } from 'react-redux'
import classes from 'classnames'

import { ui } from '../redux'

import ButtonGroup from '../components/ButtonGroup'

class DropdownMenu extends Component {
    handleClickOutside() {
        const { name, isOpen, dispatch } = this.props
        if (isOpen) {
            dispatch(ui.toggleMenu(name, ui.MENUS.dropdown))
        }
    }

    render() {
        const { name, children, trigger, isOpen, className, dispatch } = this.props
        return (
            <ButtonGroup isOpen={ isOpen } className={ className }>
                { React.cloneElement(trigger, {
                    ...trigger.props,
                    onClick: () => dispatch(ui.toggleMenu(name, ui.MENUS.dropdown))
                }) }
                <ul className={ classes('dropdown-menu') }>
                    { children }
                </ul>
            </ButtonGroup>
        )
    }
}

DropdownMenu.propTypes = {
    dispatch : PropTypes.func.isRequired,
    name     : PropTypes.string.isRequired,
    trigger  : PropTypes.node.isRequired,
    isOpen   : PropTypes.bool
}

function mapStateToProps(state, ownProps) {
    const { name } = ownProps
    return {
        isOpen: ui.isMenuOpen(name, ui.MENUS.dropdown)(state)
    }
}

export default connect(mapStateToProps)(onClickOutside(DropdownMenu))
